import { AxiosInstance } from "axios";
import { Establishment } from "./types";

import { BaseAPI } from "../../classes/BaseAPI";

export class EstablishmentAPI extends BaseAPI {
  constructor(axios: AxiosInstance) {
    super(axios)
  }

  async getJoinableEstablishments() {
    return await this.request<Establishment[]>('/establishments/joinable/all', 'GET')
  }
}